import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { deleteData, getData, patchData } from '../Services/api'
import Swal from 'sweetalert2'
import { toast } from 'react-toastify'

const CmsList = () => {
    const [pages, setPages] = useState([]);

    const fetchCMSPages = async () => {
        try {
            const res = await getData('/cms/all');
            if (res.status) {
                setPages(res.data || [])
            }
        } catch (error) {
            console.log("error fetch cms page", error)
        }
    }

    useEffect(() => {
        fetchCMSPages();
    }, []);

    const handleStatusChange = async (slug) => {
        try {
            const res = await patchData(`/cms/toggle/${slug}`);
            if (res.status) {
                toast.success(res.message);
                fetchCMSPages();
            }
        } catch (error) {
            console.log("error cms status change", error)
        }
    }

    const handleDelete = (slug) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const res = await deleteData(`/cms/delete/${slug}`,);
                    if (res.status) {
                        toast.success(res.message);
                        fetchCMSPages();
                    }
                } catch (error) {
                    console.log("error delete cms page", error)
                }
            }
        });
    }

    return (
        <>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="page-header">
                        <div className="page-block">
                            <div className="row align-items-center">
                                <div className="col-md-12">
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item">
                                            <Link to="/">Home</Link>
                                        </li>
                                        <li className="breadcrumb-item">
                                            <Link to="/cms/cms-list">CMS</Link>
                                        </li>
                                        <li className="breadcrumb-item" aria-current="page">
                                            CMS List
                                        </li>
                                    </ul>
                                </div>
                                <div className="col-md-12">
                                    <div className="page-header-title">
                                        <h2 className="mb-0">CMS List</h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <div className="card table-card">
                                <div className="card-body">
                                    <div className="text-end pb-sm-2 p-4">
                                        <Link
                                            to="/cms/add-cms"
                                            className="btn btn-primary d-inline-flex align-item-center"
                                        >
                                            <i className="fas fa-plus f-18 me-2" /> Add CMS
                                        </Link>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table table-hover" id="pc-dt-simple">
                                            <thead>
                                                <tr>
                                                    <th>S.No.</th>
                                                    <th>Title</th>
                                                    <th>Status</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pages?.length > 0 ? (
                                                        pages?.map((cms, index) => {
                                                            return (
                                                                <tr key={cms._id}>
                                                                    <td>{index + 1}.</td>
                                                                    <td>
                                                                        <h6 className="mb-0">{cms.title}</h6>
                                                                    </td>
                                                                    <td>
                                                                        <div className="form-check form-switch p-0">
                                                                            <input
                                                                                className="form-check-input h4 position-relative m-0"
                                                                                type="checkbox"
                                                                                role="switch"
                                                                                checked={cms.status}
                                                                                onChange={() => handleStatusChange(cms.slug)}
                                                                            />
                                                                        </div>

                                                                    </td>
                                                                    <td className="text-center">
                                                                        <ul className="list-inline me-auto mb-0">
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="View"
                                                                            >
                                                                                <Link
                                                                                    to={`/cms/view-cms/${cms.slug}`}
                                                                                    className="avtar avtar-xs btn-link-secondary btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-eye f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Edit"
                                                                            >
                                                                                <Link
                                                                                    to={`/cms/update-cms/${cms.slug}`}
                                                                                    className="avtar avtar-xs btn-link-success btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-edit f-18" />
                                                                                </Link>
                                                                            </li>
                                                                            <li
                                                                                className="list-inline-item align-bottom"
                                                                                data-bs-toggle="tooltip"
                                                                                title="Delete"
                                                                            >
                                                                                <a
                                                                                    onClick={() => handleDelete(cms.slug)}
                                                                                    className="avtar avtar-xs btn-link-danger btn-pc-default"
                                                                                >
                                                                                    <i className="fas fa-trash f-18" />
                                                                                </a>
                                                                            </li>
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    ) : (
                                                        <tr>
                                                            <td colSpan={6} className='text-center'>No CMS Page Found</td>
                                                        </tr>
                                                    )
                                                }

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CmsList